<template>
  <aside class="aside-menu">
    <div class="tab-content">
      <notification-list></notification-list>
    </div>
    <button class="bg-white navbar-toggler aside-menu-toggler d-md-down-none m-2" type="button" @click="asideToggle">
      <i class="fa fa-chevron-right"></i>
    </button>
  </aside>
</template>

<script>
import NotificationList from '@/views/notifications/Index'
export default {
  name: 'aside',
  components: {
    NotificationList
  },
  methods: {
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    }
  }
}
</script>

<style>
.aside-menu .sidebar-minimizer {
    position: relative;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 50px;
    flex: 0 0 50px;
    background-color: rgba(0, 0, 0, 0.2);
    border: 0;
}
.aside-menu-fixed .aside-menu .sidebar-minimizer::before {
  width: 100%;
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}
.aside-menu .sidebar-minimizer::before {
  position: absolute;
  top: 0;
  right: 0;
  width: 50px;
  height: 50px;
  content: "";
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 11 14'%3E%3Cpath fill='%23536c79' d='M9.148 2.352l-4.148 4.148 4.148 4.148q0.148 0.148 0.148 0.352t-0.148 0.352l-1.297 1.297q-0.148 0.148-0.352 0.148t-0.352-0.148l-5.797-5.797q-0.148-0.148-0.148-0.352t0.148-0.352l5.797-5.797q0.148-0.148 0.352-0.148t0.352 0.148l1.297 1.297q0.148 0.148 0.148 0.352t-0.148 0.352z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12.5px;
  -webkit-transition: .3s;
  transition: .3s;
}
</style>




// WEBPACK FOOTER //
// src/components/Aside.vue